import { useIntl } from 'react-intl';
import { RangeSliderFilterConfig } from '@alltrails/denali/components/FilterBar';
import ExploreServiceFilters from '../../types/ExploreServiceFilters';
import useRangeSliderFilterConfig, { getValidRangeSliderValue } from './useRangeSliderFilterConfig';

const mValues = [
  ...Array.from(Array(11).keys()).map(v => v * 30), // 0-300, in 30 increments
  ...Array.from(Array(8).keys()).map(v => v * 150 + 450) // 450-1500, in 150 increments
];

const ftValues = [
  ...Array.from(Array(11).keys()).map(v => v * 100), // 0-1000, in 100 increments
  ...Array.from(Array(8).keys()).map(v => v * 500 + 1500) // 1500-5000, in 500 increments
];

export const getValidElevationGain = (meters: number, useMetric: boolean) =>
  getValidRangeSliderValue(meters, ftValues, 'foot', mValues, 'meter', useMetric);

const useElevationGainFilterConfig = (
  exploreServiceFilters: ExploreServiceFilters,
  onFiltersChange: (updatedFilters: ExploreServiceFilters) => void,
  useMetric: boolean
): RangeSliderFilterConfig => {
  const intl = useIntl();

  return useRangeSliderFilterConfig(
    exploreServiceFilters,
    onFiltersChange,
    'elevationGain',
    intl.formatMessage({ defaultMessage: 'Elevation' }),
    ftValues,
    'foot',
    mValues,
    'meter',
    useMetric
  );
};

export default useElevationGainFilterConfig;
